var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5575 10.3154C22.4593 10.2995 22.3599 10.2921 22.2604 10.2934H5.32893L5.69812 10.1217C6.059 9.95088 6.38731 9.71841 6.66833 9.43481L11.4164 4.68678C12.0417 4.08985 12.1468 3.12956 11.6653 2.41151C11.1051 1.64634 10.0306 1.48021 9.26537 2.04049C9.20355 2.08578 9.14479 2.13515 9.08957 2.18828L0.503632 10.7742C-0.167358 11.4445 -0.167949 12.5317 0.502291 13.2027C0.50272 13.2031 0.503203 13.2036 0.503632 13.204L9.08957 21.79C9.7611 22.4596 10.8483 22.4581 11.518 21.7866C11.5707 21.7337 11.62 21.6775 11.6653 21.6183C12.1468 20.9002 12.0417 19.9399 11.4164 19.343L6.67692 14.5864C6.42498 14.3342 6.13531 14.1227 5.81833 13.9596L5.30317 13.7278H22.1659C23.0432 13.7603 23.8128 13.1476 23.9776 12.2853C24.1294 11.3492 23.4936 10.4673 22.5575 10.3154Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.2dd868f17a2da4b2d7d34a807fdc9268.svg";
export { ForwardRef as ReactComponent };